import { useRoot } from "./useRoot";

/**
 * Obtains vuex store
 */
export function useStore() {
  const root = useRoot();
  return root.$store;
}
